import styled from "styled-components"

const StyledSpinner = styled.svg`
  animation: rotate 1s linear infinite;
  margin: auto;
  width: 24px;
  height: 24px;
  border-top: 2px solid ${(props) => props.theme.palette.white};
  border-right: 2px solid ${(props) => props.theme.palette.white};
  border-left: 2px solid ${(props) => props.theme.palette.white};
  border-radius: 50%;

  &.primary-dark {
    border-top: 2px solid ${(props) => props.theme.palette.primary_dark};
    border-right: 2px solid ${(props) => props.theme.palette.primary_dark};
    border-left: 2px solid ${(props) => props.theme.palette.primary_dark};
  }
  &.size-medium {
    width: 60px;
    height: 60px;
  }
  &.path {
    stroke: ${(props) => props.theme.palette.white};
    strokelinecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  &.error {
    border-top: 2px solid ${(props) => props.theme.palette.error};
    border-right: 2px solid ${(props) => props.theme.palette.error};
    border-left: 2px solid ${(props) => props.theme.palette.error};
  }

  &.size-large {
    height: 80px;
    width: 80px;
  }

  &.secondary .path {
    stroke: ${(props) => props.theme.palette.primary_dark};
    strokelinecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`

interface SpinnerProps {
  className?: string
}

const Spinner = (props: SpinnerProps) => {
  const { className, ...rest } = props

  return (
    <StyledSpinner viewBox="0 0 50 50" className={className} {...rest}>
      <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="4" />
    </StyledSpinner>
  )
}

export default Spinner
